import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

let lastOrdenCreate = 0;
export default class Anclas extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            resource:{
                tempId:0,
                manc_ModMenuAncla_id:this.props.manc_ModMenuAncla_id,
                manc_Id:0,
                manc_Titulo:"",
                manc_Ancla:"",
                manc_Orden:0,
                manc_Activo:true,
                manc_Eliminado:false
            },
            resourceEdit:{
                tempId:0,
                manc_ModMenuAncla_id:this.props.manc_ModMenuAncla_id,
                manc_Id:0,
                manc_Titulo:"",
                manc_Ancla:"",
                manc_Orden:0,
                manc_Activo:true,
                manc_Eliminado:false
            },
            anclas:this.props.anclas,
            Validacion: {
                manc_Titulo: {
                    Error: false,                    
                },
                manc_Ancla: {
                    Error: false,                    
                },
                manc_Orden: {
                    Error: false,                    
                }
            },
            ValidacionEdit: {
                manc_Titulo: {
                    Error: false,                    
                },
                manc_Ancla: {
                    Error: false,                    
                },
                manc_Orden: {
                    Error: false,                    
                }
            },
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    showAgregar = (e) => {

        e.preventDefault();

        $(".containerFormCreationLista").fadeIn();  
        $("#btnGuardarAncla").fadeIn();
        $("#btnAgregarAncla").fadeOut();
    }

    hideAgregar = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        $(".containerFormCreationLista").fadeOut();  
        $("#btnGuardarAncla").fadeOut();
        $("#btnAgregarAncla").fadeIn();
    }

    update = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.manc_Titulo == '') {              
            newState.ValidacionEdit.manc_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.manc_Ancla == '') {              
            newState.ValidacionEdit.manc_Ancla = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.manc_Orden == '') {  
            newState.ValidacionEdit.manc_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        setTimeout(() => { 
            this.retornarAPadre();
        }, 100); 

        this.cancelarEdicion();

    }

    storeLista = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.manc_Titulo == '') {              
            newState.Validacion.manc_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.manc_Ancla == '') {              
            newState.Validacion.manc_Ancla = {Error: true};
            newState.hasError = true;
        }
        lastOrdenCreate = lastOrdenCreate + 1;
        newState.resource.manc_Orden = lastOrdenCreate;
        newState.resource.tempId = lastOrdenCreate;

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let titulo = document.getElementById("manc_Titulo").value;
        let mAncla = document.getElementById("manc_Ancla").value;

        let resource = {
            manc_Titulo:titulo,
            manc_Ancla:mAncla,
            manc_Orden:lastOrdenCreate,
            tempId:lastOrdenCreate,
            manc_Activo:1,
            manc_Id:0
        }

        var anclas = newState.anclas;
        anclas.push(resource);
        newState.anclas = anclas;
        newState.resource.manc_Titulo = "";
        newState.resource.manc_Ancla = "";
        newState.resource.manc_Orden = 0;
        

        this.setState(newState);
        this.hideAgregar();

       /* setTimeout(() => { 
            this.retornarAPadre();
        }, 100); */

    }

    cancelarEdicion = () => {
        
        this.setState({
            resourceEdit:{
                manc_Id:0,
                manc_Titulo:"",
                manc_Ancla:"",
                manc_Orden:0,
                manc_Activo:true
            }
        });
    }

    editRegistro = (entity, e) => {

        e.preventDefault();
        let newEntity = entity;
        this.setState({resourceEdit: newEntity});
    }

    eliminarRegistro = async(entity) => {
        entity.manc_Eliminado = true;

        setTimeout(() => { 
            this.retornarAPadre();
        }, 100); 
        
        return; 
    }

    actualizarEstado = (entity, e) => {

        e.preventDefault();

        //implementar
    }

    retornarAPadre = () => {

        let anclas = this.state.anclas;
        this.props.callback(anclas);        
    }

    componentWillReceiveProps(nextProps){
        lastOrdenCreate = nextProps.anclas.length;
        this.setState({anclas: nextProps.anclas})        
    } 

    render() {
        return (
            <div className="divModulo_Seo">
                <h2><strong>Anclas</strong></h2>
                <div className="divWrapperModulo_Seo">

                        {
                            this.state.anclas.length > 0 ?
                            <div className="divModuloPopup_Panel">
                                {
                                    this.state.anclas.map((ancla) => (
                                        <React.Fragment>
                                            {
                                                (! ancla.manc_Eliminado) ?  
                                                    <React.Fragment>
                                                    <div className="txtFile x-1">
                                                        <input type="text" readOnly placeholder="Titulo" value={ancla.manc_Titulo}/>
                                                        <div className="divBtnAccionesPopup_Panel">
                                                            {
                                                                ancla.manc_Id > 0 ?
                                                                <a href="#" className={ancla.manc_Activo ? "btnPageModuloVer noneEvent" : "btnPageModuloInactivo noneEvent"} onClick={(e) => this.actualizarEstado(ancla, e)}/>                       
                                                                : null
                                                            }                                                
                                                            <a href="#" className="btnPageModuloEditar noneEvent" onClick={(e) => this.editRegistro(ancla, e)}/>
															
															
                                                            <a href className="btnPageModuloEliminar aEliminarMenu2"/>
															<div className="c_divAlertaCapa">
																<div className="divAlertaCapa">
																	<div className="divAlerta">
																		<h2>&iquest;Seguro de eliminar?</h2>
																		<div className="divAlertaBtn">
																			<a href="#" className="btnAlertaAceptar" onClick={() => this.eliminarRegistro(ancla)}>ACEPTAR</a>
																			<a href="#" className="btnAlertaCancelar">CANCELAR</a>
																		</div>
																	</div>
																</div>
															</div>
															
															
                                                        </div>
                                                    </div>
                                                    {
                                                        (this.state.resourceEdit.manc_Id == ancla.manc_Id && ancla.manc_Id > 0) 
                                                        || (ancla.tempId == this.state.resourceEdit.tempId && ancla.tempId > 0)?
                                                        <div className="containerFormEdit divModuloPopup_Panel">
                                                            <div className="txtFile x-1">
                                                                <input type="text" 
                                                                placeholder="Título" 
                                                                name='manc_Titulo' 
                                                                value={this.state.resourceEdit.manc_Titulo} 
                                                                maxLength={200} 
                                                                className={this.state.ValidacionEdit.manc_Titulo.Error ? "error" : ""}  
                                                                onChange={this.handleInputChangeEdit}/>
                                                            </div>
                                                            <div className="txtFile x-1">
                                                                <input type="text" 
                                                                placeholder="Anclaje" 
                                                                name='manc_Ancla'
                                                                className={this.state.ValidacionEdit.manc_Ancla.Error ? "error" : ""}
                                                                value={this.state.resourceEdit.manc_Ancla} 
                                                                onChange={this.handleInputChangeEdit}/>
                                                            </div>

                                                            <div className="txtFile x-2">
                                                                <input type="text" placeholder="Orden" name='manc_Orden' value={this.state.resourceEdit.manc_Orden} maxLength={2} className={this.state.ValidacionEdit.manc_Orden.Error ? "error" : ""} onChange={this.handleInputChangeEdit}/>
                                                            </div>
                                                            <div className="clear"></div>
                                                            <div className="txtFile x-2">
                                                                <a href="" className="btnAgregarPagina" id="btnActualizar" onClick={(e) => this.update(e)}>ACTUALIZAR</a>
                                                                <a href="" className="btnAgregarPagina noneEvent" id="btnCancelarActualizar" onClick={() => this.cancelarEdicion()}>CANCELAR</a>
                                                            </div>
                                                            
                                                        </div>
                                                        : null
                                                    }
                                                    </React.Fragment>
                                                : null
                                            }
                                        </React.Fragment>
                                    ))
                                }
                            </div> : null
                        }
                    
                    <div className="containerFormCreationLista divModuloPopup_Panel" style={{display:"none"}}>
                        <div className="txtFile x-1">
                            <input type="text" 
                            placeholder="Título" 
                            name='manc_Titulo' 
                            id='manc_Titulo'
                            value={this.state.resource.manc_Titulo} 
                            maxLength={200} className={this.state.Validacion.manc_Titulo.Error ? "error" : ""}  
                            onChange={this.handleInputChange}/>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" 
                            placeholder="Anclaje" 
                            name='manc_Ancla'
                            id='manc_Ancla'
                            className={this.state.Validacion.manc_Ancla.Error ? "error" : ""}
                            value={this.state.resource.manc_Ancla} 
                            onChange={this.handleInputChange}/>
                        </div>

                    </div>

                    <div style={{width: "100%"}}>
                        <a href="" className="btnAgregarPagina" id="btnAgregarAncla" onClick={(e) => this.showAgregar(e)}>AGREGAR</a>
                        <a href="" style={{display:"none"}} className="btnAgregarPagina" id="btnGuardarAncla" onClick={(e) => this.storeLista(e)}>AGREGAR</a>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    
                </div>
            </div>
        )
    }
}
